import React from 'react';
import "./../../View.css";
import "./../../Grid.css";
import "./../../Form.css";
import "./../../App.css";
import "./LearnerDocuments.css"
import EnhancedTable from '../../widgets/ResponsiveTable';

const headCells = [
    { id: 'ImpactofLearning', numeric: false, disablePadding: true, label: 'Impact Of Learning' },
    { id: 'UploadedBy', numeric: false, disablePadding: true, label: 'Uploaded By' },
    { id: 'UploadDate', numeric: false, disablePadding: true, label: 'Upload Date' },
    { id: 'DocumentName', numeric: false, disablePadding: true, label: 'Photo', contentType: 'document' }
]

export default function ImpactOfLearningDocuments(props, ref) {
    return (
        <EnhancedTable headCells={headCells} onCellSelectionChange={(rowid, columnid) => { props.handleCell(rowid, columnid) }} searchParameters={[{ Name: `${props.moduleName}ID`, Value: props.selection }]} paged={false}
            dataUrl={props.documentsDataUrl !== null ? props.documentsDataUrl : null} 
        />
    );
}
